var styles = {
  "checkbox": "_checkbox_zbp1q8_10",
  "sizeS": "_sizeS_zbp1q8_22",
  "sizeM": "_sizeM_zbp1q8_28",
  "sizeL": "_sizeL_zbp1q8_34",
  "errorMessage": "_errorMessage_zbp1q8_40",
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_zbp1q8_1",
  "list": "_list_zbp1q8_44",
  "single": "_single_zbp1q8_48",
  "input": "_input_zbp1q8_53",
  "icon": "_icon_zbp1q8_64",
  "enabled": "_enabled_zbp1q8_75",
  "indeterminate": "_indeterminate_zbp1q8_95",
  "disabled": "_disabled_zbp1q8_120",
  "checkmark": "_checkmark_zbp1q8_154",
  "themeLight": "_themeLight_zbp1q8_191",
  "error": "_error_zbp1q8_40",
  "themeDark": "_themeDark_zbp1q8_216",
  "classic": "_classic_zbp1q8_247",
  "rock": "_rock_zbp1q8_334"
};
export { styles as default };
